module.exports = __webpack_public_path__ + "img/左边板块标题样式.ad41a86c.png";